import { NS_CONFIGURATION, PROJECT, EDITOR, ITEM, CURRENT, STATUS } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';

export const {
  INIT,
  SET_STATUSES,
  SET_STATUS_ID,
  SET_COLOR,
  SET_STATUS_TYPE,
  SET_DEFAULT_STATUS,
  SET_COMPLETED_ON_SPRINT,
  SET_CALCULATE_SPENT_TIME,
  ADD_FLOW,
  ADD_COMPLETED,
  REMOVE,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, ITEM, CURRENT, STATUS)({
    INIT: ASYNC,
    SET_STATUSES: ASYNC,
    SET_STATUS_ID: SYNC,
    SET_COLOR: SYNC,
    SET_STATUS_TYPE: SYNC,
    SET_DEFAULT_STATUS: SYNC,
    SET_COMPLETED_ON_SPRINT: SYNC,
    SET_CALCULATE_SPENT_TIME: SYNC,
    ADD_FLOW: SYNC,
    ADD_COMPLETED: SYNC,
    REMOVE: SYNC,
  });

export const init = {
  begin: ({ statuses }) => action(INIT.BEGIN, { statuses }),
  end: ({
    defaultStatusId,
     }) => action(INIT.END, {
      defaultStatusId,
    }),
};
export const setStatuses = {
  begin: ({ statuses }) => action(SET_STATUSES.BEGIN, { statuses }),
  end: ({
    initialStatus,
    flowStatuses,
    completedStatuses,
   }) => action(SET_STATUSES.END, {
      initialStatus,
      flowStatuses,
      completedStatuses,
    }),
};
export const setStatusId = ({ localId, statusId }) => action(SET_STATUS_ID, { localId, statusId });
export const setColor = ({ localId, color }) => action(SET_COLOR, { localId, color });
export const setStatusType = ({ localId, statusType }) => action(SET_STATUS_TYPE, { localId, statusType });
export const setDefaultStatus = ({ statusId }) => action(SET_DEFAULT_STATUS, { statusId });
export const setCompletedOnSprint = ({ localId, value }) => action(SET_COMPLETED_ON_SPRINT, { localId, value });
export const setCalculateSpentTime = ({ localId, value }) => action(SET_CALCULATE_SPENT_TIME, { localId, value });
export const addFlow = () => action(ADD_FLOW);
export const addCompleted = () => action(ADD_COMPLETED);
export const remove = ({ localId }) => action(REMOVE, { localId });



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/statusFlow/actions.js